module.exports = __webpack_public_path__ + "img/store3.cfba0d03.png";